import { render, staticRenderFns } from "./bscClueZhaoBiaoList.vue?vue&type=template&id=d882e124&scoped=true"
import script from "./bscClueZhaoBiaoList.vue?vue&type=script&lang=js"
export * from "./bscClueZhaoBiaoList.vue?vue&type=script&lang=js"
import style0 from "./bscClueZhaoBiaoList.vue?vue&type=style&index=0&id=d882e124&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d882e124",
  null
  
)

export default component.exports